import script from "./MenuLateral.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuLateral.vue?vue&type=script&setup=true&lang=js"

import "./MenuLateral.vue?vue&type=style&index=0&id=afff894c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afff894c"]])

export default __exports__